import React from "react";
import Login from "./Login";

const Auth: React.FC = () => {
  return <Login />;
};

export default Auth;
